import request from '@/utils/axios';

import {
  LOAD_SELECTED_PROFILE_BEGIN,
  LOAD_SELECTED_PROFILE_ERROR,
  LOAD_SELECTED_PROFILE_SUCCESS,
  SET_UPDATE_PROFILE_FORM_DATA,
} from './types';

const setFormData = (name, value) => ({
  type: SET_UPDATE_PROFILE_FORM_DATA,
  payload: {
    name,
    value,
  },
});

const loadProfileBegin = () => ({
  type: LOAD_SELECTED_PROFILE_BEGIN,
  payload: {
    loadingProfile: true,
  },
});
const loadProfileError = () => ({
  type: LOAD_SELECTED_PROFILE_ERROR,
  payload: {
    loadingProfile: false,
  },
});
const loadProfileSuccess = data => ({
  type: LOAD_SELECTED_PROFILE_SUCCESS,
  payload: {
    loadingProfile: false,
    isMailingAddressDisabled: !data.PoBox.Number,
    ...data,
  },
});

export const handleFormChange = (name, value) => {
  return async dispatch => {
    await dispatch(setFormData(name, value));
  };
};

export const getProfileDetails = personId => {
  return async dispatch => {
    try {
      dispatch(loadProfileBegin());
      const profileResponse = await request({
        url: '/profile/details',
        method: 'GET',
        params: {
          personId,
        },
      });
      const { data } = profileResponse;
      dispatch(loadProfileSuccess(data));
    } catch (err) {
      dispatch(loadProfileError());
      throw err;
    }
  };
};

export const submitRequest = payload => {
  console.log({ payload });
};
